// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3fXH_","productName":"Table_productName__2CYaA"};